import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Sales from './pages/Sales';
import Utms from './pages/Utms';
import Campaigns from './pages/Campaigns';
import Automations from './pages/Automations';
import Webhooks from './pages/Webhooks';
import Settings from './pages/Settings';
import WhatsAppHealth from './pages/WhatsAppHealth';
import { Loader2 } from 'lucide-react';
import NotificationBell from './components/NotificationBell';

const AppLayout = ({ children }) => (
  <div className="flex min-h-screen bg-gray-900">
    <Sidebar />
    <main className="flex-1 overflow-auto pt-14 lg:pt-0 lg:ml-64">
      <div className="hidden lg:flex items-center justify-end px-6 py-3 border-b border-gray-800">
        <NotificationBell />
      </div>
      <div className="lg:hidden fixed top-0 right-12 z-50 py-3">
        <NotificationBell />
      </div>
      {children}
    </main>
  </div>
);

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="min-h-screen bg-gray-900 flex items-center justify-center"><Loader2 className="animate-spin text-blue-500" size={40} /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin()) return <Navigate to="/" replace />;
  return <AppLayout>{children}</AppLayout>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/sales" element={<ProtectedRoute><Sales /></ProtectedRoute>} />
          <Route path="/utms" element={<ProtectedRoute><Utms /></ProtectedRoute>} />
          <Route path="/campaigns" element={<ProtectedRoute><Campaigns /></ProtectedRoute>} />
          <Route path="/automations" element={<ProtectedRoute><Automations /></ProtectedRoute>} />
          <Route path="/webhooks" element={<ProtectedRoute><Webhooks /></ProtectedRoute>} />
          <Route path="/whatsapp-health" element={<ProtectedRoute><WhatsAppHealth /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          {/* Rotas antigas redirecionam */}
          <Route path="/account" element={<Navigate to="/settings" replace />} />
          <Route path="/notifications" element={<Navigate to="/settings" replace />} />
          <Route path="/meta-logs" element={<Navigate to="/webhooks?tab=logs" replace />} />
          <Route path="/users" element={<Navigate to="/settings?tab=users" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
